var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
var DataRangeFiltersDrawer = function (_ref) {
    var onClose = _ref.onClose, request = _ref.request;
    function getDateRange(option) {
        var _fromDate, _toDate;
        var today = new Date();
        var fromDate, toDate = new Date(today);
        switch (option === null || option === void 0 ? void 0 : option.Name) {
            case "Week to Date":
                fromDate = new Date(today);
                fromDate.setDate(today.getDate() - today.getDay() + 1);
                break;
            case "Month to Date":
                fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
                break;
            case "Previous Month":
                fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                toDate = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "Year to Date":
                fromDate = new Date(today.getFullYear(), 0, 1);
                break;
            case "Previous Year":
                if (today.getMonth() + 1 < 4) {
                    fromDate = new Date(today.getFullYear() - 2, 3, 1);
                    toDate = new Date(today.getFullYear() - 1, 2, 31);
                }
                else {
                    fromDate = new Date(today.getFullYear() - 1, 3, 1);
                    toDate = new Date(today.getFullYear(), 2, 31);
                }
                break;
            case "Custom":
            default:
                return {
                    from: null,
                    to: null
                };
        }
        var fromISO = (_fromDate = fromDate) === null || _fromDate === void 0 ? void 0 : _fromDate.toISOString();
        var toISO = (_toDate = toDate) === null || _toDate === void 0 ? void 0 : _toDate.toISOString();
        return {
            fromISO: fromISO,
            toISO: toISO
        };
    }
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "supplier",
            columnSize: 12,
            mt: 2,
            bgcolor: "overlay.white",
            flexDirection: "row",
            justifyContent: "space-between",
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: "",
                    columnSize: true,
                    display: "flex",
                    pl: 2,
                    item: false,
                    elements: [{
                            type: FormItemTypes.Box,
                            name: "",
                            display: "flex",
                            flexDirection: "row",
                            mt: 1,
                            columnSize: 10,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "status",
                                    value: "Filters",
                                    fontSize: "xxl",
                                    fontWeight: "bold",
                                    columnSize: 0,
                                    color: "info",
                                    sx: {
                                        ml: 1,
                                        borderRadius: 1
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "DataRange",
                    label: "Date Range",
                    placeholder: "Select Data Range",
                    columnSize: 12,
                    options: [{
                            id: "weekToDate",
                            Name: "Week to Date"
                        }, {
                            id: "MonthToDate",
                            Name: "Month to Date"
                        }, {
                            id: "PreviousMonth",
                            Name: "Previous Month"
                        }, {
                            id: "YearToDate",
                            Name: "Year to Date"
                        }, {
                            id: "PreviousYear",
                            Name: "Previous Year"
                        }, {
                            id: "custom",
                            Name: "Custom"
                        }],
                    setFormState: function (fromValue, currentValue) {
                        var date = getDateRange(currentValue);
                        return _objectSpread(_objectSpread({}, fromValue), {}, {
                            DataRange: currentValue,
                            FromDate: date.fromISO,
                            ToDate: date.toISO
                        });
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    columnSize: 12,
                    name: "",
                    setFieldProps: function (fromValue) {
                        return fromValue.DataRange === 'custom' ? {
                            type: FormItemTypes.ContainerItem,
                            elements: [{
                                    type: FormItemTypes.DatePicker,
                                    label: "Date",
                                    placeholder: "Form",
                                    name: "FromDate",
                                    columnSize: 6
                                }, {
                                    type: FormItemTypes.Box,
                                    name: "",
                                    mt: 3,
                                    columnSize: true,
                                    elements: [{
                                            type: FormItemTypes.DatePicker,
                                            placeholder: "To",
                                            name: "ToDate",
                                            columnSize: 12,
                                            sx: {
                                                marginTop: 2
                                            }
                                        }]
                                }]
                        } : {
                            type: FormItemTypes.ContainerItem
                        };
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'Footer',
            columnSize: 12,
            justifyContent: 'end',
            sx: {
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                padding: 2,
                backgroundColor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Reset filters',
                    columnSize: 0,
                    variant: 'outlined',
                    onClick: function () { return 'reset'; }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Apply',
                    columnSize: 0,
                    variant: 'contained',
                    setFieldProps: function (formValues) {
                        console.log("reacheddd here");
                        return {
                            type: FormItemTypes.Button,
                            disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.DataRange) === "custom" ? !(formValues !== null && formValues !== void 0 && formValues.FromDate && formValues !== null && formValues !== void 0 && formValues.ToDate) : false
                        };
                    },
                    onClick: function () { return 'submit'; }
                }]
        }];
    return /*#__PURE__*/ React.createElement(Box, {
        p: 2,
        sx: {
            paddingTop: {
                md: "60px",
                lg: "60px"
            },
            position: 'relative',
            // Ensure the parent container is positioned relatively
            height: '100%' // Ensure the container takes full height
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0,
            gap: "20px"
        },
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        success: true,
                        data: request
                    }];
            });
        }); },
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref2.request;
                console.log('Apply Btn');
                onClose(request);
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); },
        formData: formData
    }));
};
export default DataRangeFiltersDrawer;
